module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<button class="push-btn btn btn-grey">Push</button>\n<button class="publish-btn btn btn-white">Publish</button>\n\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/editor/editorMoreMenu/PushPublishButtonView.tpl
// module id = 2919
// module chunks = 0